import { render, staticRenderFns } from "./PersonOrgDetailsUserInfo.vue?vue&type=template&id=57fd694e&"
import script from "./PersonOrgDetailsUserInfo.vue?vue&type=script&lang=js&"
export * from "./PersonOrgDetailsUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports